import { PATIENT_TYPES } from '@/views/constants'
import { helpers } from 'vuelidate/lib/validators'

export const validAppointmentTypeByPatientType = (configurations = [], filters = { newPatientFilter: false }) => {
  if (!Array.isArray(configurations)) {
    return false
  }
  const curPatientType = filters.newPatientFilter ? PATIENT_TYPES.NEW : PATIENT_TYPES.RETURNING
  return configurations.some(config => {
    return config && Array.isArray(config.patientTypeFilter) ? config.patientTypeFilter.includes(curPatientType) : false
  })
}

export const validLegacyReasonType = (reasonType, filters = { newPatientFilter: false }) => {
  const validReasonTypes = ['all']
  validReasonTypes.push(filters.newPatientFilter ? 'new' : 'existing')

  return validReasonTypes.includes(reasonType)
}

export const createListForInputSelect = (list = [], textProperty = 'text') => {
  return [...list]
    .sort((a, b) => a.sortId - b.sortId)
    .map(({ id, [textProperty]: text }) => ({ value: id, text }))
}

export class CustomError extends Error {
  constructor (message, additionalData = {}, name = 'CustomError') {
    super(message)
    for (const k in additionalData) {
      this[k] = additionalData[k]
    }
    this.name = name // name shouldn't be modified in a hidden way (inside additionalData)
  }
}

// Input validation for aphabetical characters with optional quotes and apostrophes
export const alphaWithQuotes = helpers.regex('alphaWithQuotes', /^\b([-,a-zA-ZÀ-ÿ.'`]+[ ]*)+$/)
